import { TVLBadge } from "entities/tvl";
import { ConnectWalletButton } from "features/connect-wallet";
import { useResponsive } from "shared/hooks/use-responsive";

import { HeaderLink } from "./header-link";
import { Menu } from "./menu/menu";

export const Header = () => {
  const { md } = useResponsive();

  return (
    <>
      <TVLBadge className="justify-center rounded-none py-2 md:hidden" />
      <header className="relative grid grid-cols-2 items-center gap-x-3 p-3.5 md:grid-cols-[110px_1fr_1fr]">
        {md ? (
          <img src="/bento-logo-white.svg" className="w-[91px]" />
        ) : (
          <Menu />
        )}
        <ul className="hidden gap-x-3 md:flex">
          <li>
            <HeaderLink to="/">Pre-Deposit</HeaderLink>
          </li>
          <li>
            <HeaderLink to="/portfolio">Portfolio</HeaderLink>
          </li>
        </ul>
        <div className="flex items-center gap-x-2 justify-self-end">
          <TVLBadge className="hidden md:flex" />
          <ConnectWalletButton />
        </div>
      </header>
    </>
  );
};
